const FadeLeftD0 = {
  initial: { opacity: 0, x: 100 },
  enter: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
  exit: {
    opacity: 0,
    y: -30,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
};

const FadeRightD0 = {
  initial: { opacity: 0, x: -100 },
  enter: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
  exit: {
    opacity: 0,
    y: -30,
    transition: {
      duration: 0.5,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
};

const FadeUpD0 = {
  initial: { opacity: 0, y: 50 },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.333,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
  exit: {
    opacity: 0,
    y: -30,
    transition: {
      duration: 0.333,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
};

const FadeUpD1 = {
  initial: { opacity: 0, y: 50 },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.333,
      delay: 0.333,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
  exit: {
    opacity: 0,
    y: -30,
    transition: {
      duration: 0.1,
      delay: 0.333,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
};

const HeroParent = {
  initial: { opacity: 0, y: 50 },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.333,
      delay: 0.333,
      ease: 'easeOut',
      staggerChildren: 0.1,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    y: -30,
    transition: {
      duration: 0.1,
      delay: 0.333,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
};

const HeroChildren = {
  initial: { opacity: 0, y: 20 },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.333,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.1,
      ease: 'easeOut',
    },
  },
};

const FAQParent = {
  initial: { opacity: 0, y: 50 },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.333,
      ease: 'easeOut',
      staggerChildren: 0.1,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    y: -30,
    transition: {
      duration: 0.1,
      delay: 0.333,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
};

const FAQChildren = {
  initial: { opacity: 0, y: -20 },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.333,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.1,
      ease: 'easeOut',
    },
  },
};

const BodyParent = {
  initial: { opacity: 0, y: 50 },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.15,
      ease: 'easeOut',
      staggerChildren: 0.1,
      when: 'beforeChildren',
    },
  },
  exit: {
    opacity: 0,
    y: -30,
    transition: {
      duration: 0.1,
      ease: 'easeOut',
      staggerChildren: 0.1,
    },
  },
};

const BodyChildren = {
  initial: { opacity: 0, y: 20 },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.333,
      ease: 'easeOut',
    },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.1,
      ease: 'easeOut',
    },
  },
};

export const fadeUpParent = {
  initial: {
    opacity: 0,
    y: 30,
  },
  enter: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.333,
      ease: [0.19, 0.7, 0.95, 1],
      staggerChildren: 0.1,
      when: 'beforeChildren',
    },
  },
};

export const animatedParent = {
  initial: {
    opacity: 1,
  },
  enter: {
    opacity: 1,
    transition: {
      duration: 0.2,
      ease: [0.19, 0.7, 0.95, 1],
      staggerChildren: 0.1,
      when: 'beforeChildren',
    },
  },
};

export const fadeUpChild = {
  initial: {
    opacity: 0,
    translateY: 20,
  },
  enter: {
    opacity: 1,
    translateY: 0,
    transition: { duration: 0.3, ease: [0.19, 0.7, 0.95, 1] },
  },
};

export const fadeLeftChild = {
  initial: {
    opacity: 0,
    translateX: -20,
  },
  enter: {
    opacity: 1,
    translateX: 0,
    transition: { duration: 0.3, ease: [0.19, 0.7, 0.95, 1] },
  },
};

export const fadeRightChild = {
  initial: {
    opacity: 0,
    translateX: 20,
  },
  enter: {
    opacity: 1,
    translateX: 0,
    transition: { duration: 0.3, ease: [0.19, 0.7, 0.95, 1] },
  },
};

export const fadeInChild = {
  initial: {
    opacity: 0,
  },
  enter: {
    opacity: 1,
    transition: { duration: 0.3, ease: [0.19, 0.7, 0.95, 1] },
  },
};

export {
  FadeUpD0,
  FadeUpD1,
  HeroParent,
  HeroChildren,
  FadeLeftD0,
  FadeRightD0,
  FAQParent,
  FAQChildren,
  BodyParent,
  BodyChildren,
};
